module.exports = __webpack_public_path__ + "static/proprioceptive_b-a8185de42895c75f4a8e8fd47227212e.png";